import { graphql } from "gatsby";
import React from "react";
import { withPreview } from 'gatsby-source-prismic'

import SEO from "../components/common/seo";
import BegrowerComponent from "../components/begrower/begrower";
import Layout from "../components/begrower/layout";

const Begrower = ({ data }) => {
  const socials = data?.prismicSocialNetworksWhite?.data?.social_networks_white?.map(
    (social) => ({
      name: social?.icon?.alt || "",
      iconURL: social?.icon?.fixed?.src || "",
      linkURL: social?.url?.url || "",
      iconSize: social?.scale || 1,
    })
  ) || [];

  const rawInfo = data?.prismicBegrower?.data || {};
  const info = {
    socialTitle: rawInfo?.social_title || "",
    address: (rawInfo?.address || []).map(({ line }) => line),
    email: rawInfo?.email || "",
    title: rawInfo?.title || "",
    subtitle: rawInfo?.subtitle || "",
    content: rawInfo?.content?.html || "",
    clients: (rawInfo?.clients || []).map(({ logo }) => ({
      src: logo?.fixed?.src || "",
      name: logo?.alt || "",
    })),
    contactFormIntroduction: rawInfo?.contact_form_introduction?.html || "",
  };

  return (
    <Layout>
      <BegrowerComponent socials={socials} {...info} />
      <SEO title="Begrower" description="Stay lucid and keep on branding." />
    </Layout>
  );
};

export default withPreview(Begrower);

export const query = graphql`
  query BegrowerQuery {
    prismicSocialNetworksWhite {
      id
      data {
        social_networks_white {
          icon {
            fixed {
              src
            }
            alt
          }
          scale
          url {
            url
          }
        }
      }
    }
    prismicBegrower {
      id
      data {
        address {
          line
        }
        clients {
          logo {
            fixed {
              src
            }
            alt
          }
        }
        content {
          html
        }
        contact_form_introduction {
          html
        }
        email
        social_title
        subtitle
        title
      }
    }
  }
`; 